import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { formatDate } from "@/lib/format";
import { CarFront } from "lucide-react";

export const dueText = (s) => (s < 0 ? `lewat ${-s} hari` : s === 0 ? "hari ini" : `${s} hari lagi`);
export const kmText = (s) => (s < 0 ? `lewat ${(-s).toLocaleString("id-ID")} km` : `sisa ${s.toLocaleString("id-ID")} km`);
const chipText = (r) => (r.tipe === "km"
  ? `${r.plat_no} · Ganti Oli di ${Number(r.km_service_berikut).toLocaleString("id-ID")} km (${kmText(r.sisa_km)})`
  : `${r.plat_no} · ${r.dokumen} ${formatDate(r.tanggal)} (${dueText(r.sisa_hari)})`);

export default function VehicleDueAlert() {
  const { user } = useAuth();
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/vehicles-due").then((r) => setRows(r.data)).catch(() => {}); }, []);
  if (!rows.length) return null;
  const late = rows.some((r) => (r.tipe === "km" ? r.sisa_km < 0 : r.sisa_hari < 0));
  return (
    <div className={`rounded-xl border px-4 py-3 ${late ? "border-rose-300 bg-rose-50" : "border-amber-300 bg-amber-50"}`} data-testid="vehicle-due-alert">
      <div className={`flex items-center gap-2 text-sm font-bold ${late ? "text-rose-800" : "text-amber-800"}`}>
        <CarFront className="h-4 w-4" /> {rows.length} pengingat kendaraan (Pajak / STNK 30 hari, Ganti Oli ≤500 km)
        {user?.role !== "viewer" && <Link to="/vehicles" className="ml-auto text-xs font-semibold underline" data-testid="vehicle-due-link">Lihat</Link>}
      </div>
      <div className="mt-2 flex flex-wrap gap-2">
        {rows.slice(0, 10).map((r, i) => (
          <span key={i} className={`rounded-full px-2.5 py-1 text-xs font-semibold ${(r.tipe === "km" ? r.sisa_km < 0 : r.sisa_hari < 0) ? "bg-rose-600 text-white" : "bg-white text-amber-900 border border-amber-200"}`} data-testid={`vehicle-due-${i}`}>
            {chipText(r)}
          </span>
        ))}
      </div>
    </div>
  );
}
